/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:02:00 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2021-12-22 13:45:09
 */
<template>
  <div class="blank">
    <img :src="blankSrc" :style="style" />
    <el-button v-if="btnText" type="primary" size="mini" plain @click="$emit('btnClick')">{{
      btnText
    }}</el-button>
    <div v-if="text" class="blank-text">{{ text }}</div>
    <div v-if="subText" class="blank-text-sub">{{ subText }}</div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import BlankImg from "@/assets/images/blank/blank.png"
// import BlankImgOrange from "@/assets/images/blank/blank_orange.png"
import Bus from "@/components/doc/bus";
export default {
  name: "Blank",
  components: {
    [Button.name]: Button,
  },
  props: {
    width: Number,
    height: Number,
    btnText: String,
    text: String,
    subText: String,
    src: {
      type: String,
      default: BlankImg,
    },
  },
  computed: {
    style() {
      return {
        width: this.width + "px",
        height: this.height + "px",
      };
    },
  },
  data(){
    return {
      blankSrc: this.src
    }
  },
  created() {
    Bus.$on("changeTheme", (val) => {
      //  this.blankSrc = val == 'blue' ? BlankImg : BlankImgOrange
    })
  }
};
</script>
<style lang="scss" scoped>
.blank {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: #acb2bf;

  img {
    width: 20%;
  }

  .el-button {
    margin-top: 30px;
    padding: 7px 10px;
    font-size: 12px;
    border-color: #2f7bfb;
    background-color: transparent;
    border-radius: 8px;
  }

  &-text {
    margin-top: 10px;
    line-height: 1;
  }

  &-text-sub {
    margin-top: 10px;
  }
}</style>